
import axios from "axios";
import {API_URL} from "@env";

export const getUrl = (urlId) => {
    return axios.get(API_URL + `/s/${urlId}`);
}
